
import { Placement } from '@post-office/placements-frontend/backlog-placement';
export default Placement;
